import { Component, OnInit } from '@angular/core';
import { CreditCardService } from 'epay-library';
import { CommonSettings } from 'epay-library';

@Component({
  selector: 'epay-creditcard-cancel',
  templateUrl: './creditcard-cancel.component.html',
})
export class CreditCardCancelComponent implements OnInit {
  pagetitle = 'Credit Card Payment Cancelled';
  baseurl = CommonSettings.BaseApi;
  clientId = CommonSettings.ClientID;

  constructor() {}

  ngOnInit(): void {

  }
}
